"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildScrumTree = buildScrumTree;
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const TasksGlobal_1 = require("../../TasksGlobal/TasksGlobal");
/** Przycina zadania wg predykatu, USUWAJĄC gałęzie bez pasujących zadań (zachowuje przodków). */
function pruneTasks(data, keep) {
    const result = [];
    for (const cwc of data) {
        const milestones = [];
        for (const mwc of cwc.milestonesWithCases || []) {
            const cases = [];
            for (const cwt of mwc.casesWithTasks || []) {
                const tasks = (cwt.tasks || []).filter(keep);
                const subCases = (cwt.subCasesWithTasks || [])
                    .map((s) => ({ caseItem: s.caseItem, tasks: (s.tasks || []).filter(keep) }))
                    .filter((s) => s.tasks.length > 0);
                if (tasks.length > 0 || subCases.length > 0)
                    cases.push({ caseItem: cwt.caseItem, tasks, subCasesWithTasks: subCases });
            }
            if (cases.length > 0)
                milestones.push({ milestone: mwc.milestone, casesWithTasks: cases });
        }
        if (milestones.length > 0)
            result.push({ id: cwc.id, contract: cwc.contract, milestonesWithCases: milestones });
    }
    return result;
}
/** Filtruje zadania-liście wg predykatu, ale ZACHOWUJE wszystkie węzły (kontrakty/kamienie/sprawy). */
function filterLeaves(data, keep) {
    return data.map((cwc) => ({
        ...cwc,
        milestonesWithCases: (cwc.milestonesWithCases || []).map((mwc) => ({
            ...mwc,
            casesWithTasks: (mwc.casesWithTasks || []).map((cwt) => ({
                ...cwt,
                tasks: (cwt.tasks || []).filter(keep),
                subCasesWithTasks: (cwt.subCasesWithTasks || []).map((s) => ({
                    ...s,
                    tasks: (s.tasks || []).filter(keep),
                })),
            })),
        })),
    }));
}
/** true jeśli zadanie ma uzupełnione godziny szacowane LUB którekolwiek rzeczywiste (pon-pt). */
function hasFilledHours(t) {
    return !!(t.estimatedHours ||
        t.hoursMon ||
        t.hoursTue ||
        t.hoursWed ||
        t.hoursThu ||
        t.hoursFri);
}
/**
 * Buduje drzewo scrumboardu reużywając buildTree z widoku "Projekty i zadania"
 * (identyczne nazwy/układ kamieni i spraw). Filtr właściciela/statusu z zachowaniem przodków,
 * zwijanie gałęzi bez zadań, opcjonalnie tylko kontrakty "W trakcie".
 */
function buildScrumTree(data, opts) {
    const notBacklog = (t) => !opts.excludeBacklog || t.status !== MainSetupReact_1.default.TaskStatus.BACKLOG;
    const keep = (t) => notBacklog(t) &&
        (!opts.ownerId || t._owner?.id === opts.ownerId) &&
        (!opts.hoursFilledOnly || hasFilledHours(t)) &&
        (!opts.caseId || t._parent?.id === opts.caseId);
    let filtered = data;
    if (opts.ownerId || opts.hoursFilledOnly || opts.caseId) {
        // Filtr osoby/godzin: pokazujemy tylko gałęzie z pasującymi zadaniami
        // (usuwamy puste, zachowując przodków)
        filtered = pruneTasks(filtered, keep);
    }
    else if (opts.excludeBacklog) {
        // Bez filtrów zawężających: ukrywamy tylko zadania Backlog, ale zostawiamy całą strukturę
        // (kontrakty/kamienie/sprawy bez zadań pozostają widoczne, tylko zwinięte)
        filtered = filterLeaves(filtered, notBacklog);
    }
    if (opts.onlyInProgress)
        filtered = filtered.filter((c) => c.contract.status === MainSetupReact_1.default.ContractStatuses.IN_PROGRESS);
    return (0, TasksGlobal_1.buildTree)(filtered, undefined, undefined, {
        collapseEmpty: true,
        leavesRepository: opts.leavesRepository,
    });
}
